import { isRangeWithinRange } from "@teselagen/range-utils";
export default function convertOldSequenceDataToNewDataType(oldTeselagenJson, opts) {
  if (opts && opts.splitLocations) {
    oldTeselagenJson && oldTeselagenJson.features.forEach(function(feature) {
      if (feature.locations && feature.locations[0]) {
        if (feature.locations.length > 1) {
          for (let i = 1; i < feature.locations.length; i++) {
            const location = feature.locations[i];
            const clonedFeature = JSON.parse(JSON.stringify(feature));
            clonedFeature.start = location.start;
            clonedFeature.end = location.end;
            delete clonedFeature.locations;
            oldTeselagenJson.features.push(clonedFeature);
          }
        }
        feature.start = feature.locations[0].start;
        feature.end = feature.locations[0].end;
      }
      delete feature.locations;
    });
  } else {
    oldTeselagenJson && oldTeselagenJson.features.forEach(function(feature) {
      if (feature.locations && feature.locations[0]) {
        feature.start = feature.locations[0].start;
        feature.end = feature.locations[feature.locations.length - 1].end;
        if (feature.locations.length > 1) {
          const locationError = feature.locations.some((location) => {
            return !isRangeWithinRange(
              location,
              feature,
              oldTeselagenJson.sequence.length
            );
          });
          if (locationError) {
            delete feature.locations;
          }
        } else {
          delete feature.locations;
        }
      }
    });
  }
  if (Array.isArray(oldTeselagenJson.sequence)) {
    oldTeselagenJson.sequence = oldTeselagenJson.sequence.join("");
  }
}
